import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, ChevronLeft, ChevronRight } from '@outdoor-voices/ui';
import { Image } from '@outdoor-voices/ui';
import { KEY_CODES, KEY_DOWN } from '@outdoor-voices/ui/dist/config/constants';
import { useEffect } from 'react';
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { REVIEW } from './queries';
import css from './PhotoView.module.scss';
import dateString from '../../utils/dates/toString';
import parseISOLocal from '../../utils/dates/parseISOLocal';
import Rating from '../Rating';
import Stats from './Stats';
import Response from './Response';
import ViewAllPhotos from '../ViewAllPhotos';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var reviewType = {
  body: PropTypes.string,
  createdAt: PropTypes.string,
  downvotes: PropTypes.number,
  fitRating: PropTypes.number,
  heightFeet: PropTypes.number,
  heightInches: PropTypes.number,
  image: PropTypes.shape({}),
  name: PropTypes.string,
  rating: PropTypes.number,
  response: PropTypes.string,
  sizePurchased: PropTypes.string,
  usualSizePurchased: PropTypes.string,
  upvotes: PropTypes.number
};

var Review = function Review(_ref) {
  var body = _ref.body,
      createdAt = _ref.createdAt,
      fetching = _ref.fetching,
      fitRating = _ref.fitRating,
      heightFeet = _ref.heightFeet,
      heightInches = _ref.heightInches,
      image = _ref.image,
      name = _ref.name,
      rating = _ref.rating,
      response = _ref.response,
      sizePurchased = _ref.sizePurchased,
      summary = _ref.summary,
      usualSizePurchased = _ref.usualSizePurchased,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("div", {
    className: css.content,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.imageWrap,
      children: /*#__PURE__*/_jsx("div", {
        className: css.image,
        children: !fetching && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          alt: "A customer named ".concat(name, " wearing ").concat(title, " - ").concat(image.alt),
          sizes: [568],
          width: Math.min(1136, image.width),
          wrap: false
        }))
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.review,
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.title,
        children: title
      }), !fetching && /*#__PURE__*/_jsxs(_Fragment, {
        children: [summary && /*#__PURE__*/_jsx("div", {
          className: css.summary,
          children: summary
        }), /*#__PURE__*/_jsx("div", {
          className: css.rating,
          children: /*#__PURE__*/_jsx(Rating, {
            size: 18,
            value: rating
          })
        }), /*#__PURE__*/_jsx("p", {
          className: css.createdAt,
          children: dateString(parseISOLocal(createdAt))
        }), /*#__PURE__*/_jsx("p", {
          className: css.body,
          children: body
        }), response && /*#__PURE__*/_jsx(Response, {
          response: response
        }), /*#__PURE__*/_jsx(Stats, {
          autoHeight: true,
          fitRating: fitRating,
          heightFeet: heightFeet,
          heightInches: heightInches,
          modal: true,
          name: name,
          sizePurchased: sizePurchased,
          usualSizePurchased: usualSizePurchased
        })]
      }), fetching && /*#__PURE__*/_jsxs("div", {
        className: css.fetching,
        "aria-busy": "true",
        children: [/*#__PURE__*/_jsx("div", {
          "aria-hidden": "true",
          className: cc([css.rating, css.loading]),
          children: /*#__PURE__*/_jsx(Rating, {
            size: 18,
            value: 0
          })
        }), /*#__PURE__*/_jsx("p", {
          "aria-hidden": "true",
          className: cc([css.createdAt, css.loading]),
          children: "\xA0"
        }), /*#__PURE__*/_jsx("p", {
          "aria-hidden": "true",
          className: cc([css.body, css.loading]),
          children: "\xA0"
        })]
      })]
    })]
  });
};

Review.propTypes = _objectSpread(_objectSpread({}, reviewType), {}, {
  actions: PropTypes.node,
  fetching: PropTypes.bool,
  title: PropTypes.string.isRequired
});

var PhotoView = function PhotoView(_ref2) {
  var _data$review, _data$review$photoPag, _data$review$photoPag2, _data$review2, _data$review2$photoPa, _data$review2$photoPa2, _data$review3;

  var closeButton = _ref2.closeButton,
      id = _ref2.id,
      on = _ref2.on,
      onSetReview = _ref2.onSetReview,
      onShowPhotos = _ref2.onShowPhotos,
      orderBy = _ref2.orderBy,
      title = _ref2.title;

  var _useQuery = useQuery({
    query: REVIEW,
    variables: {
      id: id,
      orderBy: orderBy
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  var nextId = (data === null || data === void 0 ? void 0 : (_data$review = data.review) === null || _data$review === void 0 ? void 0 : (_data$review$photoPag = _data$review.photoPagination) === null || _data$review$photoPag === void 0 ? void 0 : (_data$review$photoPag2 = _data$review$photoPag.nextReview) === null || _data$review$photoPag2 === void 0 ? void 0 : _data$review$photoPag2.id) || null;
  var previousId = (data === null || data === void 0 ? void 0 : (_data$review2 = data.review) === null || _data$review2 === void 0 ? void 0 : (_data$review2$photoPa = _data$review2.photoPagination) === null || _data$review2$photoPa === void 0 ? void 0 : (_data$review2$photoPa2 = _data$review2$photoPa.previousReview) === null || _data$review2$photoPa2 === void 0 ? void 0 : _data$review2$photoPa2.id) || null;
  useEffect(function () {
    if (!on) {
      return;
    }

    var onKeyDown = function onKeyDown(event) {
      if (event.key === KEY_CODES.ARROW_RIGHT) {
        if (nextId) onSetReview({
          id: nextId
        });
      }

      if (event.key === KEY_CODES.ARROW_LEFT) {
        if (previousId) onSetReview({
          id: previousId
        });
      }
    };

    document.removeEventListener(KEY_DOWN, onKeyDown);
    document.addEventListener(KEY_DOWN, onKeyDown);
    return function () {
      document.removeEventListener(KEY_DOWN, onKeyDown);
    };
  }, [on, id, previousId, nextId, onSetReview]);
  var review = (data === null || data === void 0 ? void 0 : data.review) || false;
  var pagination = data === null || data === void 0 ? void 0 : (_data$review3 = data.review) === null || _data$review3 === void 0 ? void 0 : _data$review3.photoPagination;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.header,
      children: [/*#__PURE__*/_jsx(ViewAllPhotos, {
        onClick: function onClick() {
          onShowPhotos(true);
        }
      }), closeButton]
    }), /*#__PURE__*/_jsx("div", {
      className: css.previousButton,
      children: /*#__PURE__*/_jsx(Button, {
        ariaLabel: "Click to view the previous review",
        disabled: fetching || previousId === null,
        icon: true,
        onClick: function onClick() {
          onSetReview({
            id: previousId
          });
        },
        tabIndex: on ? 0 : -1,
        children: /*#__PURE__*/_jsx(ChevronLeft, {})
      })
    }), /*#__PURE__*/_createElement(Review, _objectSpread(_objectSpread({}, review), {}, {
      fetching: fetching,
      key: review.id,
      title: title
    })), /*#__PURE__*/_jsx("div", {
      className: css.nextButton,
      children: /*#__PURE__*/_jsx(Button, {
        ariaLabel: "Click to view the next review",
        disabled: fetching || nextId === null,
        icon: true,
        onClick: function onClick() {
          onSetReview({
            id: nextId
          });
        },
        tabIndex: on ? 0 : -1,
        children: /*#__PURE__*/_jsx(ChevronRight, {})
      })
    }), pagination && /*#__PURE__*/_jsxs("div", {
      className: css.pagination,
      children: [pagination.currentPage, " / ", pagination.totalCount]
    })]
  });
};

PhotoView.propTypes = {
  closeButton: PropTypes.node,
  id: PropTypes.string.isRequired,
  on: PropTypes.bool.isRequired,
  onSetReview: PropTypes.func.isRequired,
  onShowPhotos: PropTypes.func.isRequired,
  orderBy: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default PhotoView;